import React, { useEffect, useState } from "react";
import {
  Banner,
  Search,
  Services as ServicesComponent,
} from "../../components";

import { services } from "../../data";
import PageMeta from "../../seo/PageMeta";

const Services = () => {
  const [filtered, setFiltered] = useState(services);

  useEffect(() => {
    window.scroll({ behavior: "smooth", top: 0 });
  }, []);

  const handleSearch = (e) => {
    setFiltered(e);
  };

  return (
    <div className="flex flex-col items-center w-full">
      <PageMeta
        title="Cleaning Services in Melbourne, Australia"
        description="Home, office, restaurant, medical centre, warehouse, gym, school, retail and hotel cleaning in Melbourne, Australia by Clear Choice Cleaning Services."
        path="/services"
        image="/assets/images/banners/services.webp"
      />
      <Banner page="services" heading="Our Services" />

      <div className="search-section max-w-screen-xl flex flex-col justify-center items-center py-10 pb-0 md:pb-10 gap-4">
        <p className="text-5xl text-blue-6 mb-10 px-5 xl:px-0">
          Find Your Perfect Cleaning Solution
        </p>
        <p className="text-xl px-5 xl:px-0">
          Discover the full range of tasks included in each of our cleaning
          services. This section provides everything you need to know about how
          Clear Choice can meet your cleaning needs. <br />
          <br />
          Use the search options below to explore our comprehensive service
          options to find the perfect solution for your places.
        </p>

        <div className="w-3/4 pt-9 z-20">
          <Search
            data={services}
            placeholder="What are you looking for..."
            onSearch={handleSearch}
          />
        </div>
      </div>
      {filtered.length > 0 ? (
        <ServicesComponent page="services" data={filtered} />
      ) : (
        <div className="pt-5 pb-10">
          <p className="text-xl el-messiri italic text-blue-6">No Data Found</p>
        </div>
      )}
    </div>
  );
};

export default Services;
